/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import { useNavigate } from "react-router-dom";
import OTPInput, { ResendOTP } from "otp-input-react";
import { loginCompanyCustomer, loginCustomer, sendOTP, virifyOtpLogin } from './api'
import { getComapnyByKey, goToLink } from './projectData'


const loginSchema = Yup.object().shape({
    mobile: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
        .required('Mobile number is required'),
    // password: Yup.string()
    //     .min(3, 'Minimum 3 symbols')
    //     .max(50, 'Maximum 50 symbols')
    //     .required('Password is required'),
    //   password: Yup.string()
    //     .required('Password is required')
    //     .min(8, 'Password must be at least 8 characters')
    //     .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    //     .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    //     .matches(/[0-9]/, 'Password must contain at least one number')
    //     .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
})



/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function CustomerLogin() {
    const { company } = useParams();
    const [projectData, setProjectDta] = useState(null);
    const [project_key, setProject] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showOTP, setShowOTP] = useState(false); // State to control OTP input visibility
    const [OTP, setOTP] = useState('');
    const [apiError, setApiError] = useState(''); // State to handle API errors
    const [termsCondition, setTermCondition] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const projectData = getComapnyByKey(company);

        if (projectData) {
            setProject(projectData?.pkey);
            setProjectDta(projectData);
        } else {
            localStorage.removeItem('ckey');
            localStorage.removeItem('pkey');
            localStorage.removeItem('company_login');
            localStorage.removeItem('cuslogin');
            navigate('/error/404');
        }
    }, [company, navigate])

    const formik = useFormik({
        initialValues: {
            mobile: '',
            project_key: project_key

        },
        validationSchema: loginSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            setApiError(''); // Reset the API error before API call

            if (!showOTP) {
                try {
                    let otpData = {
                        mobile: values.mobile,
                        project_key: values?.project_key,
                        type: 'login'

                    }

                    if (projectData?.ckey) {
                        otpData = {
                            mobile: values.mobile,
                            company_key: projectData?.ckey,
                            type: 'login'

                        }
                    }

                    const response = await sendOTP(otpData);
                    if (Number(response.code) === 1) {
                        // OTP sent successfully, show OTP input
                        setShowOTP(true);
                    } else {
                        // Handle case where OTP sending failed
                        setStatus(response.message || 'Failed to send OTP');
                    }
                } catch (error) {
                    // Handle API error
                    setStatus(error?.response?.data?.message);
                    //   setApiError(error.message);
                } finally {
                    setLoading(false);
                }
            } else {
                // Second stage: validate OTP and submit the form
                setLoading(true);
                try {
                    const otpResponse = await virifyOtpLogin({
                        mobile: values.mobile,
                        otp: OTP,
                    });

                    if (Number(otpResponse.code) === 1) {
                        // OTP verification success, proceed to form submission or redirection
                        if (projectData?.scheme_dashboard) {
                            const responseToken = await loginCompanyCustomer({
                                mobile: values.mobile,
                                company_key: projectData?.ckey,
                                type: 'otp',
                                otp: OTP
                            });

                            if (Number(responseToken.code) === 1) {
                                localStorage.setItem('cuslogin', JSON.stringify(responseToken?.data))
                                localStorage.setItem('ckey', projectData?.ckey)
                                localStorage.setItem('company_login', company)
                                goToLink(navigate, '/customer/scheme-dashboard', [])
                                setTimeout(() => {
                                    window.location.reload();
                                }, 500);
                                //navigate('/customer/dashboard')
                            } else {
                                setStatus(responseToken.message || 'Company Login Token Error');
                            }
                        } else {
                            const responseToken = await loginCustomer({
                                mobile: values.mobile,
                                project_key: values.project_key,
                                type: 'otp',
                                otp: OTP
                            });

                            if (Number(responseToken.code) === 1) {
                                localStorage.setItem('cuslogin', JSON.stringify(responseToken?.data))
                                localStorage.setItem('pkey', values.project_key)
                                localStorage.setItem('company', company)
                                goToLink(navigate, '/customer/dashboard', [])
                                setTimeout(() => { window.location.reload(); }, 500);
                                //navigate('/customer/dashboard')
                            } else {
                                setStatus(responseToken.message || 'Login Token Error');
                            }
                        }

                    } else {
                        // OTP verification failed
                        setStatus(otpResponse.message || 'Invalid OTP');
                    }
                } catch (error) {
                    // Handle OTP verification error
                    setStatus('Error verifying OTP. Please try again.');
                    setApiError(error.message);
                } finally {
                    setLoading(false);
                }
            }
        },
    });
    const renderTime = (remainingTime) => {
        return <></>
    };
    const renderButton = (buttonProps) => {
        return buttonProps.remainingTime !== 0 ? `Please wait for ${buttonProps.remainingTime} sec` : <> <span className="text-muted me-1">Didn’t get the code ?</span> <a href="#" onClick={() => ResendOTP()} className="link-primary fw-semibolder fs-5 me-1">Resend</a></>
    };

    return (
        <div style={{ backgroundImage: `url(${toAbsoluteUrl(`${projectData?.login_bg_image}`)})` }} className="d-flex flex-column flex-lg-row flex-column-fluid vh-100 justify-content-center align-items-center">
            <div className="d-flex flex-center w-lg-100 p-10 justify-content-center flex-column align-items-center h-100">
                <div style={{ background: '#fbfbfb' }} className="card  rounded-3 w-lg-900px">
                    <div className="card-body p-2 p-lg-20">
                        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                            <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-3 order-2 order-lg-1">
                                <div className="text-left">
                                    <img
                                        className={projectData?.logo_class}
                                        src={projectData?.logo}
                                        alt=""
                                    />
                                </div>

                                <form
                                    className="form w-100 mt-10"
                                    onSubmit={formik.handleSubmit}
                                    noValidate
                                    id="kt_login_signin_form"
                                >
                                    {!showOTP && (
                                        <div className="text-left mb-11">
                                            <h1 className="text-dark fw-semibolder mb-3">Sign In</h1>
                                            <div className="text-gray-500 fw-semibold fs-6">
                                                {projectData?.login_tag_line}
                                            </div>
                                        </div>)}
                                    {showOTP && (
                                        <div className="text-left mb-11">
                                            <h1 className="text-dark fw-semibolder mb-3">Enter OTP</h1>
                                            <div className="text-gray-500 fw-semibold fs-6">
                                                Enter the OTP that you have received on your registered mobile number.
                                            </div>
                                        </div>
                                    )}

                                    {formik.status && (
                                        <div className="mb-lg-15 alert alert-danger">
                                            <div className="alert-text font-weight-bold">{formik.status}</div>
                                        </div>
                                    )}

                                    {!showOTP && (
                                        <>
                                            {/* begin::Form group */}
                                            <div className="fv-row mb-10">
                                                <label className="form-label fs-6 fw-semibolder text-dark">Mobile</label>
                                                <input
                                                    placeholder="eg. 9999999999"
                                                    {...formik.getFieldProps('mobile')}
                                                    className={clsx(
                                                        'form-control form-control-lg',
                                                        { 'is-invalid': formik.touched.mobile && formik.errors.mobile },
                                                        {
                                                            'is-valid': formik.touched.mobile && !formik.errors.mobile,
                                                        }
                                                    )}
                                                    type="text"
                                                    name="mobile"
                                                    autoComplete="off"
                                                />
                                                {formik.touched.mobile && formik.errors.mobile && (
                                                    <div className="fv-plugins-message-container">
                                                        <span role="alert" className="text-danger">
                                                            {formik.errors.mobile}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {/* end::Form group */}
                                            {projectData?.login_terms_condition &&
                                                <div class="form-check text-body d-flex  mb-5">
                                                    <input
                                                        class="form-check-input me-2"
                                                        type="checkbox"
                                                        onClick={() => setTermCondition(!termsCondition)}
                                                        value=""
                                                        id="form2Example3c"
                                                        checked={termsCondition}
                                                    />

                                                    <label class="form-check-label fs-7" for="form2Example3">
                                                        By proceeding, you consent to the use of your personal information as outlined in our  <Link to={`/customer/${company}/terms-condition`}>Terms & conditions</Link>.
                                                    </label>
                                                </div>
                                            }
                                        </>

                                    )}

                                    {showOTP && (
                                        <div className="mb-10 px-md-10">
                                            {/* begin::Label */}
                                            <div className="fw-semibolder text-start text-dark fs-6 mb-1 ms-1">
                                                Type your 4-digit OTP code
                                            </div>
                                            {/* end::Label */}
                                            {/* begin::Input group */}
                                            <div className="d-flex flex-wrap flex-stack">
                                                <OTPInput
                                                    value={OTP}
                                                    onChange={setOTP}
                                                    inputClassName="h-50px w-50px fs-2qx text-center  my-2"
                                                    autoFocus
                                                    OTPLength={4}
                                                    otpType="number"
                                                    inputStyles={{ border: '2px solid #000 !important', }}
                                                    disabled={false}
                                                />
                                            </div>
                                            {/* end::Input group */}
                                        </div>
                                    )}

                                    {/* begin::Action */}
                                    <div className="text-center">
                                        <button
                                            type="submit"
                                            id="kt_sign_in_submit"
                                            className="btn btn-lg btn-primary w-100 mb-5"
                                            disabled={!termsCondition && projectData?.login_terms_condition}
                                        //disabled={formik.isSubmitting}
                                        >
                                            {!loading && <span className="indicator-label">{showOTP ? 'Submit OTP' : 'Continue'}</span>}
                                            {loading && (
                                                <span className="indicator-progress" style={{ display: 'block' }}>
                                                    Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            )}
                                        </button>
                                        {showOTP &&

                                            <button
                                                type="button"
                                                className="btn btn-lg btn-dark w-100 mb-5"
                                                onClick={() => setShowOTP(false)}
                                            //  disabled={formik.isSubmitting || !formik.isValid || (showOTP && !OTP)}
                                            >
                                                Cancel
                                            </button>
                                        }
                                        {showOTP &&
                                            <div className="text-center d-flex fw-semibold fs-5">
                                                <ResendOTP renderButton={renderButton} renderTime={renderTime} />
                                            </div>
                                        }
                                    </div>
                                    {/* end::Action */}

                                    {apiError && (
                                        <div className="alert alert-danger mt-3">
                                            <div className="alert-text font-weight-bold">{apiError}</div>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {company !== 'mitr' &&
                    <div className="text-left">
                        <img
                            className="mx-auto w-150px w-md-50 w-xl-200px mt-4 mb-lg-10"
                            src={toAbsoluteUrl('/media/images/powerby.png')}
                            alt=""
                        />
                    </div>
                }
            </div>
        </div>

    )
}
